var DraftPresenter = /** @class */ (function () {
    function DraftPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    DraftPresenter.prototype.getDraftOrders = function (req) {
        var _this = this;
        this.actions.updateDraftLoader(true);
        return new Promise(function (resolve, reject) {
            _this.usecase.getDraftOrders.execute({
                onSuccess: function (data) {
                    _this.actions.getDraftOrders(data);
                    _this.actions.updateDraftLoader(false);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    _this.actions.updateDraftLoader(false);
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.draftOrderDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrderDetails.execute({
                onSuccess: function (data) {
                    _this.actions.draftOrderDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.getDraftOrderCount = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getDraftOrderCount.execute({
                onSuccess: function (data) {
                    _this.actions.updateDraftOrderCount(data.data.draftCount);
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                },
            }, req);
        });
    };
    DraftPresenter.prototype.getDraftOrderDeclaration = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrderDeclarations.execute({
                onSuccess: function (data) {
                    _this.actions.draftOrderDeclarations(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.saveDraftDocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveDraftDocs.execute({
                onSuccess: function (data) {
                    _this.actions.saveDraftDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.draftOrderUpdate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrderUpdate.execute({
                onSuccess: function (data) {
                    if (data) {
                        _this.actions.draftOrderUpdate(data);
                    }
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.deletedDraftDocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.deletedDraftDocs.execute({
                onSuccess: function (data) {
                    _this.actions.deletedDraftDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.getPreviewDocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.previewDocs.execute({
                onSuccess: function (data) {
                    _this.actions.previewDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.saveDraftOrders = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveDraftOrders.execute({
                onSuccess: function (data) {
                    _this.actions.saveDraftOrders(data);
                    resolve(data);
                },
                onError: function (error) {
                    console.log(error);
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    DraftPresenter.prototype.updateDraftOrders = function (response) {
        this.actions.updateDraftOrders(response);
    };
    return DraftPresenter;
}());
export default DraftPresenter;
